import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import "core-js/modules/es.parse-int.js";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 *  Quantity Selector
 *    Define the quantity selector component
 *
 *  Version:
 *    1.0.0 - 2020/11/28
 */
import { html, unsafeHTML, useEffect, useState } from '../../tools/utilities/component';
export var quantitySelectorCreate = function quantitySelectorCreate(p) {
  var quantity = p.quantity,
      min = p.min,
      max = p.max,
      disabled = p.disabled,
      onChange = p.onChange; //Effect to fix a chrome bug yay.

  var _useState = useState(quantity),
      _useState2 = _slicedToArray(_useState, 2),
      real = _useState2[0],
      setReal = _useState2[1];

  if (real !== quantity) setReal(quantity);
  useEffect(function () {
    return setReal(quantity);
  }, [quantity]); //States

  var minusDisabled = disabled || ( //@ts-ignore
  _typeof(min) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) ? false : quantity <= min);
  var plusDisabled = disabled || ( //@ts-ignore
  _typeof(max) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) ? false : quantity >= max);

  var qtySet = function qtySet(n) {
    setReal(n); //@ts-ignore

    if (_typeof(min) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) n = Math.max(min, n); //@ts-ignore

    if (_typeof(max) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) n = Math.min(max, n);
    onChange(n);
  }; //Events


  var plusClick = function plusClick() {
    if (plusDisabled) return;
    qtySet(real + 1);
  };

  var minusClick = function minusClick() {
    if (minusDisabled) return;
    qtySet(real - 1);
  };

  var inputChange = function inputChange(e) {
    var input = e.target;
    qtySet(parseInt(input.value));
  };

  return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    <div class=\"o-quantity-selector__inner has-js\">\n      <button type=\"button\" ?disabled=", " @click=", "\n        class=\"o-quantity-selector__button is-minus ", "\"\n      >\n        ", "\n      </button>\n\n      <div class=\"o-quantity-selector__input\">\n        <input type=\"number\" .value=", " @change=", "\n          class=\"o-quantity-selector__input-field  ", "\"\n        />\n      </div>\n\n      <button type=\"button\" ?disabled=", " @click=", "\n        class=\"o-quantity-selector__button is-plus ", "\"\n      >\n        ", "\n      </button>\n    </div>\n  "])), minusDisabled, minusClick, minusDisabled ? 'is-disabled' : '', unsafeHTML('<svg class="o-quantity-selector__icon is-minus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.333 8h9.333"/></svg>'), real, inputChange, disabled ? 'is-disabled' : '', plusDisabled, plusClick, plusDisabled ? 'is-disabled' : '', unsafeHTML('<svg class="o-quantity-selector__icon is-plus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 3.333v9.334M3.332 8h9.333"/></svg>'));
};